import { useInitiateOauthTrigger } from 'hooks/useInitiateOauthTrigger/useInitiateOauthTrigger'
import { InitiateOauthTriggerProps } from 'components/ConnectIntegrationTrigger/Types'
import { PressResponder } from '@react-aria/interactions'
import { mergeProps } from '@react-aria/utils'

export const InitiateOauthTrigger = (props: InitiateOauthTriggerProps) => {
  const { children, provider, popUp, accountToRefreshId, onInitiatedOauth, ...pressProps } = props
  const { handleConnect } = useInitiateOauthTrigger({
    provider,
    popUp,
    accountToRefreshId,
    onInitiatedOauth,
  } as InitiateOauthTriggerProps)

  return <PressResponder {...mergeProps(pressProps, { onPress: handleConnect })}>{children}</PressResponder>
}
